import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import style from './Parking.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import CallButtonBox from '../../../../components/box/CallButtonBox';
import imgSeoul from '../../../../images/user/img_seoul_parking.svg';

//Accordion
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


const Parking = () => {

    const location = useLocation();
    const { hsptlCd } = location.state || {};

    const hospitCds = hsptlCd;

    const hospitalAddresses = {
        "012": {
            name: "서울성모병원",
            phoneNumber: "02-2258-6000"
        },
        "011": {
            name: "여의도성모병원",
            phoneNumber: "02-3779-1495"
        },
        "015": {
            name: "은평성모병원",
            phoneNumber: "02-1811-7755"
        },
        "013": {
            name: "의정부성모병원",
            phoneNumber: "031-820-3296, 5256(야간)"
        },
        "014": {
            name: "부천성모병원",
            phoneNumber: "032-340-2630"
        },
        "016": {
            name: "인천성모병원",
            phoneNumber: "1544-9004"
        },
        "018": {
            name: "대전성모병원",
            phoneNumber: "042-220-9074"
        },
    };

    const hospital = hospitalAddresses[hospitCds];

    //Accordion
    const [expanded, setExpanded] = React.useState('panel1');

    const acHandleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };


    return (
        <>
            <HeadSub title="주차 안내" hospitalName={hospital?.name}/>

                <div id="sub-content" data-type="b" data-layout="white">
                    <div className='inner-wrap'>

                        <div className={style['mid-box']}>
                            <div className="accordion-wrap" data-type="c">


                                {/* 서울성모병원 :: S */}
                                {hospitCds === "012" && (
                                    <div className={style['content-box']}>
                                        <Accordion expanded={expanded === 'panel1'} onChange={acHandleChange('panel1')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1-content"
                                                id="panel1-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    주차 요금 안내
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">

                                                    <div className={style['accordion-cont-box']}>
                                                        <p className={style['point-p']}>유공자, 장애우 차량은 50% 감면, 정산 시 등록카드를 제시하여 주십시오.</p>

                                                        <div className={style['list-box']} data-list-type="a">
                                                            <ul>
                                                                <li>
                                                                    <p>주간</p>
                                                                    <span>오전 6시~ 오후 10시 (초과시 15분당 1,000원)</span>
                                                                </li>
                                                                <li>
                                                                    <p>야간</p>
                                                                    <span>오후 10시~ 익일 오전 6시 (일괄 1,000원)</span>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                        <hr />

                                                        <div className={style['list-box']} data-list-type="b">
                                                            <ul>
                                                                <li>
                                                                    <p>입차 후 30분 무료</p>
                                                                </li>
                                                                <li>
                                                                    <p>지하1층 주차안내데스크에서 당일권(10,000원/당일)을 구입하여 이용하시면 편리합니다.(입원환자 보호자에 한함)</p>
                                                                </li>
                                                                <li>
                                                                    <p>주차차량의 귀중품 보관을 금함. 모든 도난사고에 대해서는 책임을 지지 않습니다.</p>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel2'} onChange={acHandleChange('panel2')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel2-content"
                                                id="panel2-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    무료 주차 안내
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">

                                                    <div className={style['accordion-cont-box']}>
                                                        <p className={style['point-p']}>무료주차 내원객은 출차시 진료카드 또는 진료비 영수증을 제시해 주시면 됩니다. (사전 무인 정산기에서도 정산 가능)</p>
                                                        <div className={style['list-box']} data-list-type="a">
                                                            <ul>
                                                                <li>
                                                                    <p>외래진료 및 검사</p>
                                                                    <span>6시간 (당일 1회)</span>
                                                                </li>
                                                                <li>
                                                                    <p>입,퇴원, 수술</p>
                                                                    <span>당일 (1회)</span>
                                                                </li>
                                                                <li>
                                                                    <p>중간 진료비 납부일</p>
                                                                    <span>납부일 (2시간) 1대 1회</span>
                                                                </li>
                                                                <li>
                                                                    <p>응급실</p>
                                                                    <span>당일 입차 후 24시간 (1회)</span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel3'} onChange={acHandleChange('panel3')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel3-content"
                                                id="panel3-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    무인 수납기에서 주차차량 등록 안내
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">

                                                    <div className={style['accordion-cont-box']}>
                                                        <p>사전 무인 정산기에서 정산 후 출차하시면 됩니다.</p>

                                                        <div className={style['list-box']} data-list-type="step">
                                                            <ul>
                                                                <li>주차차량등록선택</li>
                                                                <li>차량번호 등록 선택</li>
                                                                <li>환자번호조회</li>
                                                                <li>차량번호 4자리 입력</li>
                                                                <li>입차시간조회</li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel4'} onChange={acHandleChange('panel4')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel4-content"
                                                id="panel4-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    주차장 규모
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">

                                                    <div className={style['accordion-cont-box']}>
                                                        <div className={style['list-box']} data-list-type="a">
                                                            <ul>
                                                                <li>
                                                                    <p>지상주차장</p>
                                                                    <span>56대 (전기차 충전소 38대)</span>
                                                                </li>
                                                                <li>
                                                                    <p>지하 1층</p>
                                                                    <span>90대 (장애인 차량 9대)</span>
                                                                </li>
                                                                <li>
                                                                    <p>지하 2층</p>
                                                                    <span>253대 (장애인 차량 13대)</span>
                                                                </li>
                                                                <li>
                                                                    <p>지하 3층</p>
                                                                    <span>418대 (장애인 차량 11대)</span>
                                                                </li>
                                                                <li>
                                                                    <p>지하 4층</p>
                                                                    <span>424대 (장애인 차량 9대)</span>
                                                                </li>
                                                                <li>
                                                                    <p>지하 5층</p>
                                                                    <span>438대 (장애인 차량 9대)</span>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                        <hr />

                                                        <div className={style['list-box']} data-list-type="b">
                                                            <ul>
                                                                <li>
                                                                    <p>입출차게이트 : 5개소 (정문2, 후문2, 별관1)</p>
                                                                </li>
                                                                <li>
                                                                    <p>지상주차장 위치 : 의생명과학연구원 별관 옆</p>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                    </div>

                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel5'} onChange={acHandleChange('panel5')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel5-content"
                                                id="panel5-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    전기차 충전소 이용안내
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">
                                                    <div className={style['accordion-cont-box']}>
                                                        <p>전기차를 이용하는 내원객들의 편리한 이용을 위하여
                                                            서울성모병원은 별도 주차 및 충전 공간을 운영하고 있습니다.
                                                        </p>
                                                        <div className={style['img-box']}>
                                                            <object data={imgSeoul} aria-hidden='true'/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                    </div>
                                )}
                                {/* 서울성모병원 :: E */}


                                {/* 여의도성모 :: S */}
                                {hospitCds === "011" && (
                                    <div className={style['content-box']}>
                                        <Accordion expanded={expanded === 'panel1'} onChange={acHandleChange('panel1')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1-content"
                                                id="panel1-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    주차장 이용 및 요금안내
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">

                                                    <div className={style['accordion-cont-box']}>
                                                        <p className={style['point-p']}>운영시간 : 24시간</p>

                                                        <div className={style['list-box']} data-list-type="a">
                                                            <ul>
                                                                <li>
                                                                    <p>주간</p>
                                                                    <span>오전 8시~ 오후 10시 (초과시 15분당 1,000원)</span>
                                                                </li>
                                                                <li>
                                                                    <p>야간</p>
                                                                    <span>오후 10시~ 익일 오전 8시 (초과시간 30분당 : 500원)</span>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                        <hr />

                                                        <div className={style['list-box']} data-list-type="b">
                                                            <ul>
                                                                <li>
                                                                    <p>입차 후 30분 무료</p>
                                                                </li>
                                                                <li>
                                                                    <p>1일 최대요금 (주간 입차 시 : 64,000원 / 야간 입차 시 : 65,500원)</p>
                                                                </li>
                                                                <li>
                                                                    <p>주차장 공간 협소 문제로 정기권 판매 운영을 하지 않고 있습니다.</p>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel2'} onChange={acHandleChange('panel2')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel2-content"
                                                id="panel2-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    원내주차장
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">

                                                    <div className={style['accordion-cont-box']}>
                                                        <div className={style['list-box']} data-list-type="a">
                                                            <ul>
                                                                <li>
                                                                    <p>입원, 퇴원</p>
                                                                    <span>당일(1대 1회) 8시간</span>
                                                                </li>
                                                                <li>
                                                                    <p>수술</p>
                                                                    <span>당일(1대 1회) 8시간</span>
                                                                </li>
                                                                <li>
                                                                    <p>응급실</p>
                                                                    <span>당일(1대 1회) 24시간</span>
                                                                </li>
                                                                <li>
                                                                    <p>외래진료 및 검사</p>
                                                                    <span>당일(1대 1회) 4시간</span>
                                                                </li>
                                                                <li>
                                                                    <p>건강검진(비자)</p>
                                                                    <span>당일(1대 1회) 4시간</span>
                                                                </li>
                                                                <li>
                                                                    <p>사전정산</p>
                                                                    <span>본관 2층 출구(주차안내데스크 옆), 본관 1층 후문 입,출차부스 옆, 본관 지하2층 중앙엘리베이터 옆</span>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                        <hr />

                                                        <div className={style['list-box']} data-list-type="b">
                                                            <ul>
                                                                <li>
                                                                    <p>주차요금은 100% 카드결제(현금x)</p>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                    </div>

                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel3'} onChange={acHandleChange('panel3')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel3-content"
                                                id="panel3-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                        무인 수납기 차량등록
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">

                                                    <div className={style['accordion-cont-box']}>
                                                        <div className={style['list-box']} data-list-type="a">
                                                            <ul>
                                                                <li>
                                                                    <p>활용방법</p>
                                                                    <span>진료오신 환자(보호자)분들은 수납 후 무인수납기에서 본인 차량번호를 등록하시면 주차비 감면이 자동 처리됩니다.</span>
                                                                </li>

                                                                <li>
                                                                    <p>등록안내</p>
                                                                    <div className={style['list-box']} data-list-type="b">
                                                                        <ul>
                                                                            <li>
                                                                                <p>차량번호 등록은 최초 1회 등록으로 추후 동일 차량에 대해 재등록이 필요없습니다.</p>
                                                                            </li>
                                                                            <li>
                                                                                <p>기존 등록된 차량번호가 변경된 경우 삭제후 재등록이 필요합니다.</p>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </li>

                                                            </ul>
                                                        </div>

                                                        <hr />

                                                        <div className={style['list-box']} data-list-type="b">
                                                            <ul>
                                                                <li>
                                                                    <p>입차 후 30분 무료</p>
                                                                </li>
                                                                <li>
                                                                    <p>1일 최대요금 (주간 입차 시 : 64,000원 / 야간 입차 시 : 65,500원)</p>
                                                                </li>
                                                                <li>
                                                                    <p>주차장 공간 협소 문제로 정기권 판매 운영을 하지 않고 있습니다.</p>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel4'} onChange={acHandleChange('panel4')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel4-content"
                                                id="panel4-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    주차장 이용 시 준수사항
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">

                                                    <div className={style['accordion-cont-box']}>
                                                        <div className={style['list-box']} data-list-type="b">
                                                            <ul>
                                                                <li>
                                                                    <p>주차장내에 인화물, 위험물의 진입이나 흡연 및 화기의 취급을 금합니다.</p>
                                                                </li>
                                                                <li>
                                                                    <p>주차장의 시설 또는 다른 자동차 및 기구 등에 손상을 입혔거나, 사고가 발생하였을 때는 즉시 주차사무실(구내 1495)에 신고하십시오.</p>
                                                                </li>
                                                                <li>
                                                                    <p>주차구획선 안에 주차하십시오.</p>
                                                                </li>
                                                                <li>
                                                                    <p>차내에 귀중품을 놓아두지 말고 문을 반드시 잠그어 주십시오.</p>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                    </div>

                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                    </div>
                                )}
                                {/* 여의도성모 :: E */}


                                {/* 은평성모병원 :: S */}
                                {hospitCds === "015" && (
                                    <div className={style['content-box']}>
                                        <Accordion expanded={expanded === 'panel1'} onChange={acHandleChange('panel1')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1-content"
                                                id="panel1-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    요금안내
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body" data-pad-side="0">

                                                    <div className={style['accordion-cont-box']} data-pad-side="0">
                                                        <div className={style['table-box']}>
                                                            <table>
                                                                <colgroup>
                                                                    <col width={"23%"} />
                                                                    <col width={"28%"} />
                                                                    <col width={"27%"} />
                                                                    <col width={"22%"} />
                                                                </colgroup>
                                                                <thead>
                                                                    <tr>
                                                                        <th rowSpan={2}>구분</th>
                                                                        <th colSpan={2}>내용</th>
                                                                        <th rowSpan={2}>요금납부방법</th>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>무료주차시간</th>
                                                                        <th>감면 방법</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>외래/예약, <br />
                                                                            검사 및 촬영
                                                                        </td>
                                                                        <td>8시간(1회)</td>
                                                                        <td>진료정보</td>
                                                                        <td rowSpan={5}>내원객 <br />
                                                                            키오스크 <br />
                                                                            1회 등록 <br />
                                                                            또는 <br />
                                                                            정산소확인 <br />
                                                                            (영수증 증빙)
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>입/퇴원, <br />
                                                                            수술 당일
                                                                        </td>
                                                                        <td>당일 <br />
                                                                            (입차시~24시까지)
                                                                        </td>
                                                                        <td>진료정보</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>입원기간중</td>
                                                                        <td>1일권/1만원 <br />
                                                                            (입차시~24시까지)
                                                                        </td>
                                                                        <td>등록</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>응급실, 분만</td>
                                                                        <td>24시간 <br />
                                                                            (입차시~24시간)
                                                                        </td>
                                                                        <td>진료정보</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>중간수납</td>
                                                                        <td>2시간(1회)</td>
                                                                        <td>수납확인</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>최초무료</td>
                                                                        <td colSpan={2}>입차후 30분</td>
                                                                        <td rowSpan={3}>자동인식</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>주간 <br />
                                                                            (06:00~22:00)
                                                                        </td>
                                                                        <td colSpan={2}>15분당 1,000원</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>야간 <br />
                                                                            (22:00~익일06:00)
                                                                        </td>
                                                                        <td colSpan={2}>일괄 1,000원</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>일일주차요금 상한</td>
                                                                        <td colSpan={2}>최대 30,000원</td>
                                                                        <td>정산소 & 무인정산기</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>장애인</td>
                                                                        <td colSpan={2}>복지카드 확인후 50% 감면</td>
                                                                        <td>정산소 확인</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>상주용차량</td>
                                                                        <td colSpan={2}>상가당 5~10대 무료</td>
                                                                        <td>차량등록</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>대관 주차쿠폰</td>
                                                                        <td colSpan={2}>1매당 주중 6,000 / 주말 2,000원</td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>공무</td>
                                                                        <td>2시간~4시간</td>
                                                                        <td>납품, 방문 등</td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>택배차량</td>
                                                                        <td>2시간 무료 <br />
                                                                            (당일 단시간 배송에 한함)</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                        <div className={style['list-box']} data-list-type="b">
                                                            <ul>
                                                                <li>
                                                                    <p>주차장내에 인화물, 위험물의 진입이나 흡연 및 화기의 취급을 금합니다.</p>
                                                                </li>
                                                                <li>
                                                                    <p>주차장의 시설 또는 다른 자동차 및 기구 등에 손상을 입혔거나 자기 차에 사고가 발생하였을 경우에는 즉시 관리인에게 신고해 주시기 바랍니다.</p>
                                                                </li>
                                                                <li>
                                                                    <p>주차구획선 안에 주차해 주시기 바랍니다.</p>
                                                                </li>
                                                                <li>
                                                                    <p>차내에 귀중품을 두지 마시고, 문은 반드시 잠궈 주시기 바랍니다.</p>
                                                                </li>
                                                                <li>
                                                                    <p>주차요금은 변동이 있을 수 있사오니 정확한 요금은 주차관리소의 안내를 받으시기 바랍니다.</p>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                    </div>
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                    </div>
                                )}
                                {/* 은평성모병원 :: E */}


                                {/* 의정부성모 :: S */}
                                {hospitCds === "013" && (
                                    <div className={style['content-box']}>
                                        <Accordion expanded={expanded === 'panel1'} onChange={acHandleChange('panel1')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1-content"
                                                id="panel1-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    요금 안내
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">

                                                    <div className={style['accordion-cont-box']}>

                                                        <div className={style['list-box']} data-list-type="a">
                                                            <ul>
                                                                <li>
                                                                    <p>주간</p>
                                                                    <span>06:00 ~ 22:00(30분 초과 시 10분당 500원)</span>
                                                                </li>
                                                                <li>
                                                                    <p>야간</p>
                                                                    <span>06:00 ~ 22:00(30분 초과 시 10분당 500원)</span>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                        <hr />

                                                        <div className={style['list-box']} data-list-type="b">
                                                            <ul>
                                                                <li>
                                                                    <p>무료 주차 30분 초과 시 전액 부담(예 : 40분 주차 시 2,000원 부담)</p>
                                                                </li>
                                                                <li>
                                                                    <p>주차 차량의 귀중품 보관을 금함. 모든 도난 사고에 대해서는 책임을 지지 않습니다.</p>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel2'} onChange={acHandleChange('panel2')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel2-content"
                                                id="panel2-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    정액권 안내
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">

                                                    <div className={style['accordion-cont-box']}>
                                                        <div className={style['list-box']} data-list-type="b">
                                                            <ul>
                                                                <li>
                                                                    <p>입원 환자 및 보호자 대상</p>
                                                                </li>
                                                                <li>
                                                                    <p>1일(00:00 ~ 24:00)기준 / 10,000원 선불</p>
                                                                </li>
                                                                <li>
                                                                    <p>정액권 이용 시 밤 12시까지 수시로 입·출차 가능합니다.</p>
                                                                </li>
                                                                <li>
                                                                    <p>정액권 등록처 : 주차안내소(08시 ~ 15:30분) / 지하 1층 정산소(09시 ~ 17:50분) / 지상 정산소(24시간)</p>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                    </div>

                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel3'} onChange={acHandleChange('panel3')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel3-content"
                                                id="panel3-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    요금감면
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">

                                                    <div className={style['accordion-cont-box']}>
                                                        <div className={style['list-box']} data-list-type="a">
                                                            <ul>
                                                                <li>
                                                                    <p>장애우·국가 유공자(자가운전 또는 동승)</p>
                                                                    <span>주차요금 50%</span>
                                                                </li>
                                                                <li>
                                                                    <p>외래진료·검사</p>
                                                                    <span>6시간(당일 1대에 한해 2회까지 입·출차 허용)</span>
                                                                </li>
                                                                <li>
                                                                    <p>입퇴원·수술·응급실</p>
                                                                    <span>당일 무료(1대에 한해 2회까지 입·출차 허용)</span>
                                                                </li>
                                                                <li>
                                                                    <p>중간수납</p>
                                                                    <span>2시간(당일 1회)</span>
                                                                </li>
                                                                <li>
                                                                    <p>장례식장</p>
                                                                    <span>발인일까지 상주 5대 무료(※장례식장 문의)</span>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                        <hr />

                                                        <div className={style['list-box']} data-list-type="b">
                                                            <ul>
                                                                <li>
                                                                    <p>장애우·국가 유공자 차량은 정산 시 복지카드를 제시 바랍니다.</p>
                                                                </li>
                                                                <li>
                                                                    <p>병원 이용 감면 차량은 출차 시 진료카드 또는 진료비 영수증을 제시바랍니다.</p>
                                                                </li>
                                                                <li>
                                                                    <p>최초 감면 시 자동으로 환자와 차량이 등록 되며, 다음 진료 시 자동으로 감면 됩니다.</p>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel4'} onChange={acHandleChange('panel4')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel4-content"
                                                id="panel4-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    무인정산기 위치
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">

                                                    <div className={style['accordion-cont-box']}>
                                                        <div className={style['list-box']} data-list-type="b">
                                                            <ul>
                                                                <li>
                                                                    <p>본관 1층 로비 회전문 옆</p>
                                                                </li>
                                                                <li>
                                                                    <p>본관 지하 1층 주차장 입구</p>
                                                                </li>
                                                                <li>
                                                                    <p>신관 지하 2층 입구 (장례식장 앞 주차장 전용)</p>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                    </div>

                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                    </div>
                                )}
                                {/* 의정부성모 :: E */}


                                {/* 부천성모 :: S */}
                                {hospitCds === "014" && (
                                    <div className={style['content-box']}>
                                        <Accordion expanded={expanded === 'panel1'} onChange={acHandleChange('panel1')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1-content"
                                                id="panel1-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    주차장 이용 및 요금안내
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body">

                                                    <div className={style['accordion-cont-box']}>

                                                        <div className={style['list-box']} data-list-type="a">
                                                            <ul>
                                                                <li>
                                                                    <p>주차요금</p>
                                                                    <span>10분당 300원 (추가10분당 300원)</span>
                                                                </li>
                                                                <li>
                                                                    <p>병원회송 차량</p>
                                                                    <span>20분 이내 출차 시 무료</span>
                                                                </li>
                                                                <li>
                                                                    <p>진료/검사</p>
                                                                    <span>당일 4시간 무료</span>
                                                                </li>
                                                                <li>
                                                                    <p>입원/퇴원</p>
                                                                    <span>당일 8시간 무료</span>
                                                                </li>
                                                                <li>
                                                                    <p>수술당일</p>
                                                                    <span>당일 12시간 무료</span>
                                                                </li>

                                                                <li>
                                                                    <p>응급환자(응급실)</p>
                                                                    <span>입차기준 6시간 무료 / 야간 (17:00~09:00)무료</span>
                                                                    <div className={style['list-box']} data-list-type="b" data-size="sm">
                                                                        <ul>
                                                                            <li>
                                                                                <p>당일 발행 진료 영수증 제출</p>
                                                                            </li>
                                                                            <li>
                                                                                <p>중앙안내 확인도장</p>
                                                                            </li>
                                                                            <li>
                                                                                <p>야간 정산소 확인</p>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <p>입원환자(보호자)</p>
                                                                    <span>2시간 무료: 1일1회</span>
                                                                    <div className={style['list-box']} data-list-type="b" data-size="sm">
                                                                        <ul>
                                                                            <li>
                                                                                <p>보호자 확인카드 발급(입원시 발급, 퇴원 시 반납): 출차 시, 주차권과 함께 정산소에 제출</p>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <p>인공신장실 투석환자</p>
                                                                    <span>당일무료</span>
                                                                    <div className={style['list-box']} data-list-type="b" data-size="sm">
                                                                        <ul>
                                                                            <li>
                                                                                <p>인공 신장실 확인</p>
                                                                            </li>
                                                                            <li>
                                                                                <p>중앙 안내 확인</p>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <p>공무수행,국가유공자,자원봉사,병원요청A/S차량</p>
                                                                    <span>당일무료</span>
                                                                </li>
                                                                <li>
                                                                    <p>정기 할인권</p>
                                                                    <span>5일 35,000원/ 10일,15일 70,000원 /30일 100,000원 /24HR 8,000원</span>
                                                                    <div className={style['list-box']} data-list-type="b" data-size="sm">
                                                                        <ul>
                                                                            <li>
                                                                                <p>미사용시 환불불가</p>
                                                                            </li>
                                                                            <li>
                                                                                <p>15일권은 10일권 금액에 5일 무료이용입니다.</p>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <p>경차/장애인차량</p>
                                                                    <span>50% 감액</span>
                                                                    <div className={style['list-box']} data-list-type="b" data-size="sm">
                                                                        <ul>
                                                                            <li>
                                                                                <p>일일 주차권 및 정기할인권의 경우 해당없음</p>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <p>유가족(장례식장)차량</p>
                                                                    <span>1호 : 5대 무료 / 2, 3, 5, 6, 8, 10호 : 4대 무료 / 7, 9호 : 3대 무료</span>
                                                                    <div className={style['list-box']} data-list-type="b" data-size="sm">
                                                                        <ul>
                                                                            <li>
                                                                                <p>일일 주차권은 환자가족 및 유가족에 한하여 판매</p>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                        <hr />

                                                        <div className={style['list-box']} data-list-type="b">
                                                            <ul>
                                                                <li>
                                                                    <p>운영시간 : 1주차장(24시간/ 지상은 06시 ~ 17시 운영) / 2주차장(24시간) / 3주차장(24시간)</p>
                                                                </li>
                                                                <li>
                                                                    <p>주차장 규모 : 1주차장 325대(전기차 충전면 15대 포함), 2주차장 172대, 3주차장 193대, 지상 20대</p>
                                                                </li>
                                                                <li>
                                                                    <p>본원에서는 장기 주차 및 진료와 무관한 주차로 인하여 부득이 유료화를 시행하고 있으니 이용에 차질이 없으시길 바랍니다.</p>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                    </div>
                                )}
                                {/* 부천성모 :: E */}


                                {/* 인천성모 :: S */}

                                {hospitCds === "016" && (
                                    <div className={style['content-box']}>
                                        <div className={style['first-cont-box']}>
                                            <div className={style['accordion-cont-box']} data-pad-side="0">
                                                <div className={style['list-box']} data-list-type="b">
                                                    <ul>
                                                        <li>
                                                            <p>24시간 연중무휴로 운영 됩니다.</p>
                                                        </li>
                                                        <li>
                                                            <p>차량번호인식 시스템이므로 주차권이 나오지 않고, 자동으로 차단기가 올라갑니다.</p>
                                                        </li>
                                                        <li>
                                                            <p>주차요금의 과중한 부담 방지와 외래환자 및 내원객 주차편의를 위해 입원하신 후 가족들이 차량을 회차하여 주시기 바랍니다.</p>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>


                                        <Accordion expanded={expanded === 'panel1'} onChange={acHandleChange('panel1')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1-content"
                                                id="panel1-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    요금안내
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body" data-pad-side="0">

                                                    <div className={style['accordion-cont-box']} data-pad-side="0">
                                                        <div className={style['table-box']}>
                                                            <table>
                                                                <colgroup>
                                                                    <col width={"31%"} />
                                                                    <col width={"30%"} />
                                                                    <col width={"auto"} />
                                                                </colgroup>
                                                                <thead>
                                                                    <tr>
                                                                        <th>구분</th>
                                                                        <th>요금</th>
                                                                        <th>비고</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>일반</td>
                                                                        <td>15분당 500원</td>
                                                                        <td>8시간(1회)</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>응급실 환자</td>
                                                                        <td>12시간 무료</td>
                                                                        <td rowSpan={4}>당일 1회차량 1회 한정 <br />
                                                                            진료영수증/진료카드제시(환자번호로 할인 가능)
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>입원, 퇴원, 수술 환자</td>
                                                                        <td>12시간 무료</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>외래 및 검사 환자</td>
                                                                        <td>8시간 무료</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>투석, 주사, 내시경,
                                                                            종합검진 환자
                                                                        </td>
                                                                        <td>12시간 무료</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>국가유공자/ <br />
                                                                            장애우 탑승차량
                                                                        </td>
                                                                        <td>50% 할인</td>
                                                                        <td>8시간(1회)</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                        <p>※  정기권은 환불 및 등록변경 불가.</p>

                                                    </div>
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel2'} onChange={acHandleChange('panel2')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel2-content"
                                                id="panel2-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    환자보호자 정기주차권
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body" data-pad-side="0">

                                                    <div className={style['accordion-cont-box']}>
                                                        <div className={style['table-box']}>
                                                            <table>
                                                                <colgroup>
                                                                    <col width={"25%"} />
                                                                    <col width={"25%"} />
                                                                    <col width={"25%"} />
                                                                    <col width={"25%"} />
                                                                </colgroup>
                                                                <tbody>
                                                                    <tr>
                                                                        <th>1일권</th>
                                                                        <td>10,000원</td>
                                                                        <th>7일권</th>
                                                                        <td>50,000원</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>3일권</th>
                                                                        <td>30,000원</td>
                                                                        <th>15일권</th>
                                                                        <td>70,000원</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>5일권</th>
                                                                        <td>40,000원</td>
                                                                        <th>30일권</th>
                                                                        <td>100,000원</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>

                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                    </div>
                                )}
                                {/* 인천성모 :: E */}


                                {/* 대전성모 :: S */}
                                {hospitCds === "018" && (
                                    <div className={style['content-box']}>

                                        <div className={style['first-cont-box']}>
                                            <div className={style['accordion-cont-box']} data-pad-side="0">
                                                <div className={style['list-box']} data-list-type="b">
                                                    <ul>
                                                        <li>
                                                            <p>24시간 연중무휴로 운영 됩니다.</p>
                                                        </li>
                                                        <li>
                                                            <p>차량번호인식 시스템이므로 주차권이 나오지 않고, 자동으로 차단기가 올라갑니다.</p>
                                                        </li>
                                                        <li>
                                                            <p>주차요금의 과중한 부담 방지와 외래환자 및 내원객 주차편의를 위해 입원하신 후 가족들이 차량을 회차하여 주시기 바랍니다.</p>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>


                                        <Accordion expanded={expanded === 'panel1'} onChange={acHandleChange('panel1')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1-content"
                                                id="panel1-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    주차장 구분 및 위치
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body" data-pad-side="0">

                                                    <div className={style['accordion-cont-box']} data-pad-side="0">
                                                        <div className={style['table-box']} data-type="b">
                                                            <table>
                                                                <colgroup>
                                                                    <col width={"28%"} />
                                                                    <col width={"28%"} />
                                                                    <col width={"15%"} />
                                                                    <col width={"30%"} />
                                                                </colgroup>
                                                                <thead>
                                                                    <tr>
                                                                        <th>주차장 명</th>
                                                                        <th>층수</th>
                                                                        <th>주차대수</th>
                                                                        <th>주차안내</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>상지관 지하 주차장</td>
                                                                        <td>지하 5층 ~ 지하 1층</td>
                                                                        <td>270대</td>
                                                                        <td>환자 및 보호자</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>상지관 주차장</td>
                                                                        <td>지상 1층</td>
                                                                        <td>44대</td>
                                                                        <td>환자 및 보호자</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>응급실 앞</td>
                                                                        <td>지상 1층</td>
                                                                        <td>4대</td>
                                                                        <td>응급환자 및 보호자</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>주차타워</td>
                                                                        <td>지상 1층 ~ 4층</td>
                                                                        <td>300대</td>
                                                                        <td>환자 및 보호자</td>
                                                                    </tr>

                                                                </tbody>
                                                            </table>
                                                        </div>

                                                    </div>
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion expanded={expanded === 'panel2'} onChange={acHandleChange('panel2')}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel2-content"
                                                id="panel2-header"
                                            >
                                                <div className="accordion-head">
                                                    <p className="tit">
                                                    주차요금안내
                                                    </p>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="accordion-body" data-pad-side="0">

                                                    <div className={style['accordion-cont-box']}>
                                                        <div className={style['table-box']} data-font-size="xsm">
                                                            <table>
                                                                <colgroup>
                                                                    <col width={"17%"} />
                                                                    <col width={"12%"} />
                                                                    <col width={"12.8%"} />
                                                                    <col width={"36%"} />
                                                                    <col width={"auto"} />
                                                                </colgroup>
                                                                <tbody>
                                                                    <tr>
                                                                        <th>구분</th>
                                                                        <th>주차시간</th>
                                                                        <th>요금</th>
                                                                        <th>비고</th>
                                                                        <th>확인받는 곳</th>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>외래진료,<br />
                                                                            종합검진
                                                                        </td>
                                                                        <td>4시간</td>
                                                                        <td>무료</td>
                                                                        <td className='text-align-left'>270대</td>
                                                                        <td>담당부서 확인</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td rowSpan={2}>입원환자 <br/>
                                                                            보호자 차량
                                                                        </td>
                                                                        <td rowSpan={2}>1일 6시간</td>
                                                                        <td>무료</td>
                                                                        <td className='text-align-left'>보호자등록차량 3대에 한함 <br />
                                                                            (시간합산적용) <br />
                                                                            주간(07:00~18:00)
                                                                        </td>
                                                                        <td rowSpan={2}>입 · 퇴원창구, <br />
                                                                            응급실 수납창구, <br />
                                                                            주차관리실
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="fw-400">야간주차 <br />
                                                                            4,000원
                                                                        </td>
                                                                        <td className='text-align-left'>
                                                                            18:00~익일 07:00(4,000원) <br />
                                                                            18:00~24:00(2,000원) <br />
                                                                            24:00~07:00(2,000 원)
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>응급실, 수술실, <br />
                                                                            인공신장실
                                                                        </td>
                                                                        <td>6시간</td>
                                                                        <td>무료</td>
                                                                        <td className="text-align-left">무료</td>
                                                                        <td>해당부서 6시간 이상
                                                                            수술 또는 검사시
                                                                            별도 확인
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>업무용</td>
                                                                        <td>4시간</td>
                                                                        <td>무료</td>
                                                                        <td></td>
                                                                        <td>담당부서 확인</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td rowSpan={3}>장례식장</td>
                                                                        <td>빈소당 5대(상주)</td>
                                                                        <td>무료</td>
                                                                        <td className="text-align-left">장례식장 사무실에 <br />
                                                                            등록된 차량
                                                                        </td>
                                                                        <td rowSpan={3}>장례식장 확인</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="fw-400">2시간 (조문객)</td>
                                                                        <td>무료</td>
                                                                        <td rowSpan={2} className="text-align-left">18:00~익일 07:00(4,000원) <br />
                                                                            18:00~24:00(2,000원) <br />
                                                                            24:00~07:00(2,000 원)
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="fw-400">2시간 (야간)</td>
                                                                        <td>4,000원</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>장례식장</td>
                                                                        <td>30분</td>
                                                                        <td>무료</td>
                                                                        <td rowSpan={2}  className="text-align-left">면회객, 가족, 일반인</td>
                                                                        <td rowSpan={2}></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>장례식장</td>
                                                                        <td>24시간</td>
                                                                        <td>300원/ 10분</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>장애인, <br />
                                                                            국가유공자
                                                                        </td>
                                                                        <td></td>
                                                                        <td>50% 감면</td>
                                                                        <td></td>
                                                                        <td></td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                        <p className={style['refer-txt']}>주차권을 분실하신 경우 확인절차(병원 내원환자 및 보호자확인)에 따라 주차요금을 부과할 수 있사오니, 주차권을 분실하지 않도록 주의하여 주시기 바랍니다.</p>
                                                    </div>

                                                </div>
                                            </AccordionDetails>
                                        </Accordion>

                                    </div>
                                )}
                                {/* 대전성모  :: E */}

                            </div>
                        </div>



                        <div className="bottom-fixed-box">
                            <div className="inner-box">

                            {hospital?.phoneNumber && (
                                <CallButtonBox hospital={hospital.name} phoneNumber={hospital.phoneNumber} />
                            )}
                            </div>
                        </div>


                    </div>
                </div>


        </>
    );
};

export default Parking;
